import React, { useEffect, useState, useContext } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@material-ui/core';
import iposService, { PagedResults, LogEntry, LogFilter } from 'app/services/ipos.service';
import { useSelector } from 'react-redux';
import { RootState } from 'app/main/rootReducer';
import Pagination from '@material-ui/lab/Pagination';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment-timezone';

const useStyles = makeStyles((theme: Theme) => ({
    table: {
        marginTop: theme.spacing(2),
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
}));

let now = new Date();
now.setDate(now.getDate() - 7);
let logFilter = Object.assign(new LogFilter(), {
    From: now,
    To: new Date(),
    Offset: 1,
    TraceId: null,
    Detail: null,
    Status: null,
    Level: null,
    PageLimit: 30
});

const DisplayLogEntryRow = (props: any) => {
    const { row, rowIndex } = props;
    return (<TableRow key={`index_${rowIndex}`}>
        <TableCell component="th" scope="row">{moment(row.timeStamp).format('YYYY-MMM-DD hh:MM:ss a')}</TableCell>
        <TableCell>{row.elapsedTimeMs}</TableCell>
        <TableCell>{row.method}</TableCell>
        <TableCell>{row.posName}</TableCell>
        <TableCell>{row.level}</TableCell>
        <TableCell>{row.status}</TableCell>
        <TableCell>{row.endpoint}</TableCell>
        <TableCell>{row.queryParams}</TableCell>
        <TableCell>{row.bodyParams}</TableCell>
        <TableCell>{row.remoteIpAddress}</TableCell>
        <TableCell>{row.description}</TableCell>
        <TableCell>{row.traceId}</TableCell>
    </TableRow>);
}

export default function LogComponent() {
    const classes = useStyles();
    
    const init: PagedResults<LogEntry> = {
        totalPageCount: 0,
        totalResultCount: 0,
        results: []
    };

    const [fromDate, setFromDate] = useState(logFilter.From);
    const [toDate, setToDate] = useState(logFilter.To);
    const [page, setPage] = useState(logFilter.Offset);
    const { selectedVenue } = useSelector((state: RootState) => state.venueReducer);
    const [logEntries, setLogEntries] = useState<PagedResults<LogEntry>>(init);

    const FilterContext = React.createContext(logFilter);

    async function GetLogs(venueId: number, logFilter: LogFilter): Promise<void> {

        let pagedLogEntryResults: PagedResults<LogEntry> = await iposService.GetLogEntries(venueId, logFilter);
        setLogEntries(logEntries => pagedLogEntryResults);
    }

    const handlePaginationChange = (event: any, value: any) => {

        logFilter.Offset = value;
        setPage(logFilter.Offset);
    };

    const handleOnChange = (selectedDate: Date, value?: string): void => {
        // [material-ui] KeyboardDateTimePicker requuired onChange event hanlder
    }

    const handleFromOnAccept = (selectedDate: Date, value?: string): void => {

        logFilter.From = selectedDate;
        setFromDate(selectedDate);
    };

    const handleToOnAccept = (selectedDate: Date, value?: string): void => {

        logFilter.To = selectedDate;
        setToDate(selectedDate);
    };

    useEffect(() => {
        async function execAsync() {
            await GetLogs(selectedVenue.id, logFilter);
        }
        if (selectedVenue && selectedVenue.id > 0)
            execAsync();

    }, [selectedVenue, page, fromDate, toDate])

    return (
        <FilterContext.Provider value={logFilter}>
            <div>
                <Grid container spacing={1} >
                    <Grid item xs={6} container spacing={2} direction="column" alignItems="flex-start">
                        <Grid item xs={3}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker
                                    label="From:"
                                    inputVariant="standard"
                                    variant="inline"
                                    value={fromDate}
                                    onChange={handleOnChange}
                                    onAccept={handleFromOnAccept}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={3}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker
                                    label="To:"
                                    inputVariant="standard"
                                    variant="inline"
                                    value={toDate}
                                    onChange={handleOnChange}
                                    onAccept={handleToOnAccept}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justify="flex-end">
                            <Pagination count={logEntries !== null ? logEntries.totalPageCount : 0} defaultPage={logFilter.Offset} onChange={handlePaginationChange} color="primary" variant="outlined" shape="rounded" size="medium" showFirstButton showLastButton />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} >
                        <Grid container >
                            <TableContainer component={Paper} >
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Time</TableCell>
                                            <TableCell>Duration (ms)</TableCell>
                                            <TableCell>Method</TableCell>
                                            <TableCell>PosName</TableCell>
                                            <TableCell>Level</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Endpoint</TableCell>
                                            <TableCell>Query Params</TableCell>
                                            <TableCell>Body Params</TableCell>
                                            <TableCell>IP Address</TableCell>
                                            <TableCell>Description</TableCell>
                                            <TableCell>Trace Id</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        { 
                                            logEntries !== null && logEntries.results !== null &&
                                            logEntries.results.map((logEntry, i) => <DisplayLogEntryRow key={i} row={logEntry} rowIndex={i} />)
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </FilterContext.Provider >
    );
}